import { useAuth } from '../pages/login/OAuth';

const useClientService = () => {
    const { api } = useAuth();

    const getClient = (id) =>
        api().get(`/clients/${id}`);

    const getClients = (params) =>
        api().get('/clients/', { params });

    const createClient = (data) =>
        api().post('/clients/new', data);

    const updateClient = (data) =>
        api().patch('/clients/update', data);

    const disableClient = (id) =>
        api().patch('/clients/disable', { client_id: id });

    return {
        getClient,
        getClients,
        createClient,
        updateClient,
        disableClient,
    };
};

export default useClientService;
